<template>
  <div>
    <el-row class="textLeft mb20 mt20">
      <el-col :span="24">
        <span>Time Year: </span>
        <el-select v-model="yearVal" placeholder="Please Select" class="mr5">
          <el-option
            v-for="item in yearOpt"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-button class="submitbtn" @click="handleSearch">Search</el-button>
      </el-col>
      <!-- <el-col :span="9" v-show="isType">
        <span>Time Type: </span>
        <el-select v-model="typeVal" placeholder="Please Select" class="mr5" @change="handleTimeTy">
          <el-option
            v-for="item in typeOpt"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="monthVal" placeholder="Month" class="mr5" v-show="isMonth">
          <el-option
            v-for="item in monthOpt"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="quarterVal" placeholder="Quarter" class="mr5" v-show="isQuarter">
          <el-option
            v-for="item in quarterOpt"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col> -->
      <!-- <el-col :span="6">
        <el-button class="submitbtn" @click="handleSearch">Search</el-button>
        <el-button class="submitbtn" @click="handleRecount">Recount</el-button>
      </el-col> -->
    </el-row>
    <el-card class="box-card tablecard" shadow="never">
      <div slot="header" class="clearfix textLeft">
        <span><i class="fa fa-gift fs14" /> Statistics of downloads and datasizes by project {{htitle}} </span>
      </div>
      <div>
        <!-- <h3>{{htitle}} 下载排行</h3> -->
        <div class="mb10 textRight">
          Search: <el-input size="medium" v-model="searchkey" placeholder="" class="searchInput mr5" clearable></el-input>
            <el-button class="submitbtn" @click="handleSearch">Search</el-button>
        </div>
        <el-table
          v-loading="loading"
          @sort-change="handleSort"
          :data="sData"
          height="800"
          border
          stripe
          style="width: 100%">
          <el-table-column
            prop="head"
            label="Lab Head"
            :show-overflow-tooltip="isOverflow"
            width="150"
            sortable>
          </el-table-column>
          <el-table-column
            prop="project_id"
            label="Project Id"
            width="140"
            sortable>
            <template slot-scope="scope">
              <span class="tablelink" @click="handleProurl(scope.row.project_id)">
                {{scope.row.project_id}}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="isOverflow"
            prop="project_title_english"
            label="Project title"
            sortable>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="isOverflow"
            prop="institution_english"
            label="Institution"
            sortable>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="isOverflow"
            prop="journal"
            label="Journal"
            width="200"
            sortable>
          </el-table-column>
          <el-table-column
            width="130"
            prop="download_cnt"
            label="The number of downloads"
            sortable>
          </el-table-column>
          <el-table-column
            width="160"
            prop="download_amount"
            label="The amount of data downloaded (GB)"
            sortable>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="allNum"
          :page-size="pageSize"
          @current-change="handleChangepage"
          class="pagination mb10">
        </el-pagination>
      </div>
    </el-card>
    <el-card class="box-card tablecard mt10 textLeft" shadow="never">
      <div slot="header" class="clearfix">
        <span><i class="fa fa-gift fs14" /> Top {{topnumVal}} of the number of downloads per project </span>
      </div>
      <div>
        <div class="mb20">
          Top:
          <el-select v-model="topnumVal" placeholder="请选择" class="mr5" @change="handleChangenum">
            <el-option
              v-for="item in topnumOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <!-- <el-button type="primary" @click="handleChangenum" class="mr10">Submit</el-button> -->
          <el-switch
            class="mb20"
            v-model="isShowlable"
            active-text="显示数值"
            @change="handleChangelable">
          </el-switch>
        </div>
        <div id="myCharts" :style="{height: '400px'}"></div>
      </div>
    </el-card>
    <el-card class="box-card tablecard mt10 textLeft" shadow="never">
      <div slot="header" class="clearfix">
        <span><i class="fa fa-gift fs14" /> Top {{topamVal}} of the amount of downloaded data per project </span>
      </div>
      <div>
        <div class="mb20">
          Top:
          <el-select v-model="topamVal" placeholder="请选择" class="mr5" @change="handleChangeam">
            <el-option
              v-for="item in topamOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <!-- <el-button type="primary" @click="handleChangeam" class="mr10">Submit</el-button> -->
          <el-switch
            class="mb20"
            v-model="isShowlable2"
            active-text="显示数值"
            @change="handleChangelable2">
          </el-switch>
        </div>
        <div id="myCharts2" :style="{height: '400px'}"></div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getStatDownloadDateCv, getStatDownloadData } from '@/api'
import echarts from 'echarts'
export default {
  name: 'statistics',
  data() {
    return {
      yearOpt: [],
      yearVal: 'all',
      typeOpt: [{
        value: 'month',
        label: 'Month'
      }, {
        value: 'quarter',
        label: 'Quarter'
      }, {
        value: 'year',
        label: 'Year'
      }],
      typeVal: '',
      monthVal: '',
      monthOpt: [],
      quarterVal: '',
      quarterOpt: [],
      isQuarter: false,
      isMonth: false,
      isType: false,
      isOverflow: true,
      sData: [],
      ajax_data_year: {
        search:{
          time_type: "year"
        },
        page:{
          startPage: 1,
          pageLength: 0
        },
        order:{
          item: "download_time",
          type: "desc"
        }
      },
      ajax_data_list: {
        search:{
          download_time: 'all',
          sub: ''
        },
        page:{
          startPage: 1,
          pageLength: 20
        },
        order:{
          item: "download_cnt",
          type: "desc"
        }
      },
      pageSize: 20,
      allNum: 0,
      loading: true,
      htitle: '',
      orderConvert: {
        ascending: 'asc',
        descending: 'desc'
      },
      searchkey: '',
      topnumOptions: [{
        value: '10',
        label: '10'
      }, {
        value: '15',
        label: '15'
      }, {
        value: '20',
        label: '20'
      }, {
        value: '50',
        label: '50'
      }, {
        value: '100',
        label: '100'
      }],
      topnumVal: 10,
      topamOptions: [{
        value: '10',
        label: '10'
      }, {
        value: '15',
        label: '15'
      }, {
        value: '20',
        label: '20'
      }, {
        value: '50',
        label: '50'
      }, {
        value: '100',
        label: '100'
      }],
      topamVal: 10,
      option: {
        title: {
          // text: 'Waterfall Chart',
          subtext: '次',
          left: '5%'
        },
        xAxis: {
          type: 'category',
          triggerEvent: true,
          data: [],
          axisLabel: {
            interval: 0,
            rotate: 33,
            margin: 30
          },
          nameGap: 30
        },
        yAxis: {
          type: 'value'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            // 打印确认params是对象还是数组
            // console.log(params)
            // console.log(this.chartsData1)
            // 对象：取鼠标悬浮当前项索引params.dataIndex
            // 数组：取鼠标悬浮当前项索引params[0].dataIndex
            let index = params[0].dataIndex
            let paramval = params[0].value
            // console.log(index)
            let obj = this.chartsData1[index] // 通过索引取当前项完整的接口返回值
            // console.log(obj)
            // let str = `名称：${obj.project_title_english}<br/>
            //       ID ：${obj.project_id}<br/>
            //       任务生成时间：${obj.species}<br/>`
            // if(obj.project_title_english.length > 70) {
            //   var resval = obj.project_title_english.replace(/(.{70})/g, '$1<br/>');
            //   // res += '<br/>数据值：' + params[0].value;
            //   str = str + 'ProjectName: ' + resval + `<br/>`
            //   // let proname1 = obj.project_title_english.substring(0, 80)
            //   // let proname2 = obj.project_title_english.substring(80)
            //   // str = str + 'ProjectName: ' + proname1 + `<br/>` + proname2 + `<br/>` 
            // } else {
            //   str = str + 'ProjectName: ' + obj.project_title_english + `<br/>` 
            // }
            // if(obj.institution_english.length > 80) {
            //   let instu1 = obj.institution_english.substring(0, 80)
            //   let instu2 = obj.institution_english.substring(80)
            //   str = str + 'Institution: ' + instu1 + `<br/>` + instu2 + `<br/>`
            // } else {
            //   str = str + 'Institution: ' + obj.institution_english + `<br/>` 
            // }
            // let str = `${obj.project_title_english}<br/>
            //            ${obj.project_id}<br/>
            //            ${obj.institution_english}<br/>
            //            ${obj.species}<br/>`
            let str = ''
            var pronameval = obj.project_title_english.replace(/(.{70})/g, '$1<br/>');
            // res += '<br/>数据值：' + params[0].value;
            str = str + '<span style="font-weight:800;">ProjectName: </span>' + pronameval + `<br/>`
            str = str + '<span style="font-weight:800;">ProjectID: </span>' + `${obj.project_id}<br/>`
            str = str + '<span style="font-weight:800;">Labhead: </span>' + `${obj.head}<br/>`
            var instval = obj.institution_english.replace(/(.{70})/g, '$1<br/>');
            
            str = str + '<span style="font-weight:800;">Institution: </span>' + instval + `<br/>`
            if (obj.species != '') {
              str = str + '<span style="font-weight:800;">Species: </span>' + `${obj.species}<br/>`
            }
            if (obj.diseases != '') {
              str = str + '<span style="font-weight:800;">Diseases: </span>' + `${obj.diseases}<br/>`
            }
            if (obj.tissues != '') {
              str = str + '<span style="font-weight:800;">Tissues: </span>' + `${obj.tissues}<br/>`
            }
            if (obj.cell != '') {
              str = str + '<span style="font-weight:800;">Cell: </span>' + `${obj.cell}<br/>`
            }
            if (paramval != '') {
              str = str + '<span style="font-weight:800;">The number of downloads: </span>' + `${paramval}<br/>`
            }
            // console.log(str)
            return str
          }
          // formatter: function (params) {
          //   // 假设每个数据项都有 name 和 fullName 属性，其中 fullName 是全称
          //   console.log(params)
          //   // var name = params[0].data.fullName;
          //   // return name;
          // }
          // formatter: '{a}:{b0}: {c0}<br/>{b1}: {c1}'
        },
        grid: {
          left: '2%',
          right: '5%',
          bottom: '10%',
          top: '10%',
          containLabel: true
        },
        dataZoom: [
          {
            type: 'slider',
            bottom: '1%'
          }
        ],
        series: [
          {
            data: [],
            type: 'bar',
            label: {
              show: false,
              // position: 'middle'
            }
          }
        ]
      },
      option2: {
        title: {
          // text: 'Waterfall Chart',
          subtext: '次',
          left: '5%'
        },
        xAxis: {
          type: 'category',
          triggerEvent: true,
          data: [],
          axisLabel: {
            interval: 0,
            rotate: 33,
            margin: 30
          },
          nameGap: 30
        },
        yAxis: {
          type: 'value'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            // 打印确认params是对象还是数组
            // console.log(params)
            // console.log(this.chartsData1)
            // 对象：取鼠标悬浮当前项索引params.dataIndex
            // 数组：取鼠标悬浮当前项索引params[0].dataIndex
            let index = params[0].dataIndex
            let paramval = params[0].value
            // console.log(index)
            let obj = this.chartsData2[index] // 通过索引取当前项完整的接口返回值
            // console.log(obj)
            // let str = `名称：${obj.project_title_english}<br/>
            //       ID ：${obj.project_id}<br/>
            //       任务生成时间：${obj.species}<br/>`
            // let proname1 = obj.project_title_english.substring(0, 20)
            // let proname2 = obj.project_title_english.substring(20)
            // let str = str + proname1 + `<br/>` + proname1 + `<br/>` 
            // str =     str + `${obj.project_id}<br/>
            //            ${obj.institution_english}<br/>
            //            ${obj.species}<br/>`
            // let str = `${obj.project_title_english}<br/>
            //            ${obj.project_id}<br/>
            //            ${obj.institution_english}<br/>
            //            ${obj.species}<br/>`
            // if (obj.diseases != '') {
            //   str = str + `${obj.diseases}<br/>`
            // }
            // if (obj.tissues != '') {
            //   str = str + `${obj.tissues}<br/>`
            // }
            // if (obj.cell != '') {
            //   str = str + `${obj.cell}<br/>`
            // }
            let str = ''
            var pronameval = obj.project_title_english.replace(/(.{70})/g, '$1<br/>');
            // res += '<br/>数据值：' + params[0].value;
            str = str + '<span style="font-weight:800;">ProjectName: </span>' + pronameval + `<br/>`
            str = str + '<span style="font-weight:800;">ProjectID: </span>' + `${obj.project_id}<br/>`
            str = str + '<span style="font-weight:800;">Labhead: </span>' + `${obj.head}<br/>`
            var instval = obj.institution_english.replace(/(.{71})/g, '$1<br/>');
            
            str = str + '<span style="font-weight:800;">Institution: </span>' + instval + `<br/>`
            if (obj.species != '') {
              str = str + '<span style="font-weight:800;">Species: </span>' + `${obj.species}<br/>`
            }
            if (obj.diseases != '') {
              str = str + '<span style="font-weight:800;">Diseases: </span>' + `${obj.diseases}<br/>`
            }
            if (obj.tissues != '') {
              str = str + '<span style="font-weight:800;">Tissues: </span>' + `${obj.tissues}<br/>`
            }
            if (obj.cell != '') {
              str = str + '<span style="font-weight:800;">Cell: </span>' + `${obj.cell}<br/>`
            }
            if (paramval != '') {
              paramval = paramval + 'GB'
              str = str + '<span style="font-weight:800;">The amount of data downloaded: </span>' + `${paramval}<br/>`
            }
            // console.log(str)
            return str
          }
        },
        grid: {
          left: '2%',
          right: '5%',
          bottom: '10%',
          top: '10%',
          containLabel: true
        },
        dataZoom: [
          {
            type: 'slider',
            bottom: '1%'
          }
        ],
        series: [
          {
            data: [],
            type: 'bar',
            label: {
              show: false,
              // position: 'middle'
            }
          }
        ]
      },
      isShowlable: false,
      isShowlable2: false,
      chartsData1: [],
      chartsData2: []
    }
  },
  mounted() {
  },
  created() {
    getStatDownloadDateCv(this.ajax_data_year).then(res => {
      let newData = res.result
      let dataarr = []
      newData.forEach((val, index) => {
        let filesarr = {}
        filesarr.value = val.download_time
        filesarr.label = val.download_time
        this.yearOpt.push(filesarr)
      })
      // this.yearOpt = res.result
    })
    getStatDownloadData(this.ajax_data_list).then(res => {
      // console.log(res.result)
      this.loading = false
      this.sData = this.chartsData1 = res.result
      let tbdataval = this.chartsData1
      // console.log(this.chartsData1)
      this.allNum = res.count
      var titleArray = []
      var dataArray = []
      for (var i = 0; i < this.topnumVal; i++) {
        let project_id = tbdataval[i].project_id
        let head = tbdataval[i].head
        let institution = tbdataval[i].institution_english.substring(0, 20)+'...'
        let disestr = tbdataval[i].diseases
        let diseaval = ''
        disestr.length >20 ? diseaval = disestr.substring(0, 20)+'...' : diseaval = disestr
        let tissuesstr = tbdataval[i].tissues
        let tissuesval = ''
        tissuesstr.length >20 ? tissuesval = tissuesstr.substring(0, 20)+'...' : tissuesval = tissuesstr
        let addstr = ''
        let speciesstr = tbdataval[i].species
        let speciesval = ''
        speciesstr.length >30 ? speciesval = speciesstr.substring(0, 30)+'...' : speciesval = speciesstr
        let species = speciesval
        let cellstr = tbdataval[i].cell
        let cellval = ''
        cellstr.length >10 ? cellval = cellstr.substring(0, 10)+'...' : cellval = cellstr
        let titlearr = project_id+'\n'+head+'\n'+institution+'\n'+species
        let addarr = '\n'
        if(diseaval != '') {
          addarr = addarr + diseaval
        }
        if(tissuesval != '' && diseaval != '') {
          addarr = addarr + '/'+tissuesval
        } else if(tissuesval != '' && diseaval == '') {
          addarr = addarr + tissuesval
        }
        if(tissuesval != '' && diseaval != '' && cellval != '') {
          addarr = addarr + '/' + cellval
        } else if(tissuesval != '' && diseaval == '' && cellval != '') {
          addarr = addarr + '/' + cellval
        } else if(tissuesval == '' && diseaval == '' && cellval != '') {
          addarr = addarr + cellval
        }
        titleArray.push(titlearr+addarr)
        dataArray.push(this.sData[i].download_cnt)
      }
      this.option.xAxis.data = titleArray
      this.option.series[0].data = dataArray
      this.option.title.subtext = '次'
      let charts = this.$echarts.init(document.getElementById('myCharts'))
      const _this = this
      charts.on('click', 'xAxis.category', function (params) {
        var clikName = params.value;
        let valarr = clikName.split("\n"); // 使用回车分割字符串
        let routerData = _this.$router.resolve({path: '/project', query: {id: valarr[0]}})
        window.open(routerData.href, '_blank')
      })
      charts.setOption(this.option)
      // console.log(titleArray)
    })
    this.ajax_data_list.order.item = 'download_amount'
    getStatDownloadData(this.ajax_data_list).then(res => {
      // this.loading = false
      // this.sData = res.result
      // this.allNum = res.count
      // var newArray = [...this.sData].splice(0, 10);
      this.chartsData2 = res.result
      let tbdataval = this.chartsData2
      var titleArray = []
      var dataArray = []
      for (var i = 0; i < this.topamVal; i++) {
        let project_id = tbdataval[i].project_id
        let head = tbdataval[i].head
        let institution = tbdataval[i].institution_english.substring(0, 20)+'...'
        let disestr = tbdataval[i].diseases
        let diseaval = ''
        disestr.length >20 ? diseaval = disestr.substring(0, 20)+'...' : diseaval = disestr
        let tissuesstr = tbdataval[i].tissues
        let tissuesval = ''
        tissuesstr.length >20 ? tissuesval = tissuesstr.substring(0, 20)+'...' : tissuesval = tissuesstr
        let addstr = ''
        // let species = tbdataval[i].species
        let speciesstr = tbdataval[i].species
        let speciesval = ''
        speciesstr.length >30 ? speciesval = speciesstr.substring(0, 30)+'...' : speciesval = speciesstr
        let species = speciesval
        let cellstr = tbdataval[i].cell
        let cellval = ''
        cellstr.length >10 ? cellval = cellstr.substring(0, 10)+'...' : cellval = cellstr
        let titlearr = project_id+'\n'+head+'\n'+institution+'\n'+species
        let addarr = '\n'
        if(diseaval != '') {
          addarr = addarr + diseaval
        }
        if(tissuesval != '' && diseaval != '') {
          addarr = addarr + '/'+tissuesval
        } else if(tissuesval != '' && diseaval == '') {
          addarr = addarr + tissuesval
        }
        if(tissuesval != '' && diseaval != '' && cellval != '') {
          addarr = addarr + '/' + cellval
        } else if(tissuesval != '' && diseaval == '' && cellval != '') {
          addarr = addarr + '/' + cellval
        } else if(tissuesval == '' && diseaval == '' && cellval != '') {
          addarr = addarr + cellval
        }
        titleArray.push(titlearr+addarr)
        dataArray.push(tbdataval[i].download_amount)
      }
      this.option2.xAxis.data = titleArray
      this.option2.series[0].data = dataArray
      this.option2.title.subtext = 'GB'
      let charts = this.$echarts.init(document.getElementById('myCharts2'))
      const _this = this
      charts.on('click', 'xAxis.category', function (params) {
        var clikName = params.value;
        let valarr = clikName.split("\n"); // 使用回车分割字符串
        let routerData = _this.$router.resolve({path: '/project', query: {id: valarr[0]}})
        window.open(routerData.href, '_blank')
      })
      charts.setOption(this.option2)
      // console.log(titleArray)
    })
  },
  methods: {
    handleClick() {},
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    handleTimeTy() {
      if(this.typeVal == 'month') {
        this.monthOpt = []
        this.isMonth = true
        this.isQuarter = false
        this.ajax_data_year.search.time_type = 'month'
        this.ajax_data_year.search.time_year = this.yearVal
        getStatDownloadDateCv(this.ajax_data_year).then(res => {
          let newData = res.result
          let dataarr = []
          newData.forEach((val, index) => {
            let filesarr = {}
            filesarr.value = val.download_time
            filesarr.label = val.download_time
            this.monthOpt.push(filesarr)
          })
        })
      } else if (this.typeVal == 'quarter') {
        this.quarterOpt = []
        this.isQuarter = true
        this.isMonth = false
        this.ajax_data_year.search.time_type = 'quarter'
        this.ajax_data_year.search.time_year = this.yearVal
        getStatDownloadDateCv(this.ajax_data_year).then(res => {
          let newData = res.result
          let dataarr = []
          newData.forEach((val, index) => {
            let filesarr = {}
            filesarr.value = val.download_time
            filesarr.label = val.download_time
            this.quarterOpt.push(filesarr)
          })
        })
      } else {
        this.isMonth = false
        this.isQuarter = false
      }
    },
    handleYear() {
      // if(this.yearVal != 'all') {
      //   this.isType = true
      // } else {
      //   this.isType = false
      // }
    },
    handleSearch() {
      let titleval = '( '+ this.yearVal + ' )'
      this.yearVal == 'all' ? this.htitle = '' : this.htitle = titleval
      this.loading = true
      this.ajax_data_list.search.download_time = this.yearVal
      this.ajax_data_list.search.sub = this.searchkey
      this.ajax_data_list.page.pageLength = 20
      this.ajax_data_list.page.startPage = 1
      getStatDownloadData(this.ajax_data_list).then(res => {
        this.loading = false
        this.sData = res.result
        this.allNum = res.count
      })
      this.handleCharts()
      this.handleCharts2()
      // if(this.yearVal == 'all') {
      //   this.htitle = ''
      //   this.loading = true
      //   this.ajax_data_list.search.sub = this.searchkey
      //   getStatDownloadData(this.ajax_data_list).then(res => {
      //     this.loading = false
      //     this.sData = res.result
      //     this.allNum = res.count
      //   })
      // } else {
      //   this.ajax_data_list.search.sub = this.searchkey
      //   if(this.typeVal == 'month') {
      //     this.htitle = '( '+ this.monthVal + ' )'
      //     this.loading = true
      //     this.ajax_data_list.search.download_time = this.monthVal
      //     getStatDownloadData(this.ajax_data_list).then(res => {
      //       this.loading = false
      //       this.sData = res.result
      //       this.allNum = res.count
      //     })
      //   } else if (this.typeVal == 'quarter') {
      //     this.htitle = '( '+ this.quarterVal + ' )'
      //     this.loading = true
      //     this.ajax_data_list.search.download_time = this.quarterVal
      //     getStatDownloadData(this.ajax_data_list).then(res => {
      //       this.loading = false
      //       this.sData = res.result
      //       this.allNum = res.count
      //     })
      //   } else {
      //     this.htitle = '( '+ this.yearVal + ' )'
      //     this.loading = true
      //     this.ajax_data_list.search.download_time = this.yearVal
      //     getStatDownloadData(this.ajax_data_list).then(res => {
      //       this.loading = false
      //       this.sData = res.result
      //       this.allNum = res.count
      //     })
      //   }
      // }
    },
    handleRecount() {},
    handleChangepage (val) {
      this.loading = true
      this.ajax_data_list.page.startPage = val
      getStatDownloadData(this.ajax_data_list).then(res => {
        this.loading = false
        this.sData = res.result
        this.allNum = res.count
      })
    },
    handleSort (column, prop, order) {
      // console.log(column, prop, order)
      this.loading = true
      this.ajax_data_list.order.item = column.prop
      this.ajax_data_list.order.type = this.orderConvert[column.order]
      this.ajax_data_list.page.pageLength = this.pageSize
      if (column.order !== null && column.prop !== null) {
        getStatDownloadData(this.ajax_data_list).then(res => {
          this.loading = false
          this.sData = res.result
          this.allNum = res.count
        })
      } else {
        this.loading = false
      }
    },
    handleGetStatData() {
      this.loading = true
      getStatDownloadData(this.ajax_data_list).then(res => {
        this.loading = false
        this.sData = res.result
        this.allNum = res.count
      })
    },
    handleChangenum() {
      this.ajax_data_list.order.item = 'download_cnt'
      this.ajax_data_list.page.pageLength = parseInt(this.topnumVal)
      getStatDownloadData(this.ajax_data_list).then(res => {
        // this.loading = false
        // this.sData = res.result
        // this.allNum = res.count
        // var newArray = [...this.sData].splice(0, 10);
        this.chartsData1 = res.result
        let tbdataval = this.chartsData1
        var titleArray = []
        var dataArray = []
        for (var i = 0; i < this.topnumVal; i++) {
          let project_id = tbdataval[i].project_id
          let head = tbdataval[i].head
          let institution = tbdataval[i].institution_english.substring(0, 20)+'...'
          let disestr = tbdataval[i].diseases
          let diseaval = ''
          disestr.length >20 ? diseaval = disestr.substring(0, 20)+'...' : diseaval = disestr
          let tissuesstr = tbdataval[i].tissues
          let tissuesval = ''
          tissuesstr.length >20 ? tissuesval = tissuesstr.substring(0, 20)+'...' : tissuesval = tissuesstr
          let addstr = ''
          // let species = tbdataval[i].species
          let speciesstr = tbdataval[i].species
          let speciesval = ''
          speciesstr.length >30 ? speciesval = speciesstr.substring(0, 30)+'...' : speciesval = speciesstr
          let species = speciesval
          let cellstr = tbdataval[i].cell
          let cellval = ''
          cellstr.length >10 ? cellval = cellstr.substring(0, 10)+'...' : cellval = cellstr
          let titlearr = project_id+'\n'+head+'\n'+institution+'\n'+species
          let addarr = '\n'
          if(diseaval != '') {
            addarr = addarr + diseaval
          }
          if(tissuesval != '' && diseaval != '') {
            addarr = addarr + '/'+tissuesval
          } else if(tissuesval != '' && diseaval == '') {
            addarr = addarr + tissuesval
          }
          if(tissuesval != '' && diseaval != '' && cellval != '') {
            addarr = addarr + '/' + cellval
          } else if(tissuesval != '' && diseaval == '' && cellval != '') {
            addarr = addarr + '/' + cellval
          } else if(tissuesval == '' && diseaval == '' && cellval != '') {
            addarr = addarr + cellval
          }
          titleArray.push(titlearr+addarr)
          dataArray.push(tbdataval[i].download_cnt)
        }
        this.option.xAxis.data = titleArray
        this.option.series[0].data = dataArray
        this.option.title.subtext = '次'
        let charts = this.$echarts.init(document.getElementById('myCharts'))
        const _this = this
        charts.on('click', 'xAxis.category', function (params) {
          var clikName = params.value;
          let valarr = clikName.split("\n"); // 使用回车分割字符串
          let routerData = _this.$router.resolve({path: '/project', query: {id: valarr[0]}})
          window.open(routerData.href, '_blank')
        })
        charts.setOption(this.option)
        // console.log(titleArray)
      })
    },
    handleChangeam() {
      this.ajax_data_list.order.item = 'download_amount'
      this.ajax_data_list.page.pageLength = parseInt(this.topamVal)
      getStatDownloadData(this.ajax_data_list).then(res => {
        // this.loading = false
        // this.sData = res.result
        // this.allNum = res.count
        // var newArray = [...this.sData].splice(0, 10);
        this.chartsData2 = res.result
        let tbdataval = this.chartsData2
        var titleArray = []
        var dataArray = []
        for (var i = 0; i < this.topamVal; i++) {
          let project_id = tbdataval[i].project_id
          let head = tbdataval[i].head
          let institution = tbdataval[i].institution_english.substring(0, 20)+'...'
          let disestr = tbdataval[i].diseases
          let diseaval = ''
          disestr.length >20 ? diseaval = disestr.substring(0, 20)+'...' : diseaval = disestr
          let tissuesstr = tbdataval[i].tissues
          let tissuesval = ''
          tissuesstr.length >20 ? tissuesval = tissuesstr.substring(0, 20)+'...' : tissuesval = tissuesstr
          let addstr = ''
          // let species = tbdataval[i].species
          let speciesstr = tbdataval[i].species
          let speciesval = ''
          speciesstr.length >30 ? speciesval = speciesstr.substring(0, 30)+'...' : speciesval = speciesstr
          let species = speciesval
          let cellstr = tbdataval[i].cell
          let cellval = ''
          cellstr.length >10 ? cellval = cellstr.substring(0, 10)+'...' : cellval = cellstr
          let titlearr = project_id+'\n'+head+'\n'+institution+'\n'+species
          let addarr = '\n'
          if(diseaval != '') {
            addarr = addarr + diseaval
          }
          if(tissuesval != '' && diseaval != '') {
            addarr = addarr + '/'+tissuesval
          } else if(tissuesval != '' && diseaval == '') {
            addarr = addarr + tissuesval
          }
          if(tissuesval != '' && diseaval != '' && cellval != '') {
            addarr = addarr + '/' + cellval
          } else if(tissuesval != '' && diseaval == '' && cellval != '') {
            addarr = addarr + '/' + cellval
          } else if(tissuesval == '' && diseaval == '' && cellval != '') {
            addarr = addarr + cellval
          }
          titleArray.push(titlearr+addarr)
          dataArray.push(tbdataval[i].download_amount)
        }
        this.option2.xAxis.data = titleArray
        this.option2.series[0].data = dataArray
        this.option2.title.subtext = 'GB'
        let charts = this.$echarts.init(document.getElementById('myCharts2'))
        const _this = this
        charts.on('click', 'xAxis.category', function (params) {
          var clikName = params.value;
          let valarr = clikName.split("\n"); // 使用回车分割字符串
          let routerData = _this.$router.resolve({path: '/project', query: {id: valarr[0]}})
          window.open(routerData.href, '_blank')
        })
        charts.setOption(this.option2)
        // console.log(titleArray)
      })
    },
    handleChangelable(val) {
      console.log(this.chartsData1)
      let tbdataval = this.chartsData1
      var titleArray = []
      var dataArray = []
      for (var i = 0; i < this.topnumVal; i++) {
        let project_id = tbdataval[i].project_id
        let headval = tbdataval[i].head
        let institution = tbdataval[i].institution_english.substring(0, 20)+'...'
        let disestr = tbdataval[i].diseases
        let diseaval = ''
        disestr.length >20 ? diseaval = disestr.substring(0, 20)+'...' : diseaval = disestr
        let tissuesstr = tbdataval[i].tissues
        let tissuesval = ''
        tissuesstr.length >20 ? tissuesval = tissuesstr.substring(0, 20)+'...' : tissuesval = tissuesstr
        let addstr = ''
        // let species = tbdataval[i].species
        let speciesstr = tbdataval[i].species
        let speciesval = ''
        speciesstr.length >30 ? speciesval = speciesstr.substring(0, 30)+'...' : speciesval = speciesstr
        let species = speciesval
        let cellstr = tbdataval[i].cell
        let cellval = ''
        cellstr.length >10 ? cellval = cellstr.substring(0, 10)+'...' : cellval = cellstr
        let titlearr = project_id+'\n'+headval+'\n'+institution+'\n'+species
        let addarr = '\n'
        if(diseaval != '') {
          addarr = addarr + diseaval
        }
        if(tissuesval != '' && diseaval != '') {
          addarr = addarr + '/'+tissuesval
        } else if(tissuesval != '' && diseaval == '') {
          addarr = addarr + tissuesval
        }
        if(tissuesval != '' && diseaval != '' && cellval != '') {
          addarr = addarr + '/' + cellval
        } else if(tissuesval != '' && diseaval == '' && cellval != '') {
          addarr = addarr + '/' + cellval
        } else if(tissuesval == '' && diseaval == '' && cellval != '') {
          addarr = addarr + cellval
        }
        titleArray.push(titlearr+addarr)
        dataArray.push(tbdataval[i].download_cnt)
      }
      this.option.xAxis.data = titleArray
      this.option.series[0].data = dataArray
      this.option.series[0].label.show = val
      this.option.title.subtext = '次'
      let charts = this.$echarts.init(document.getElementById('myCharts'))
      const _this = this
        charts.on('click', 'xAxis.category', function (params) {
          var clikName = params.value;
          let valarr = clikName.split("\n"); // 使用回车分割字符串
          let routerData = _this.$router.resolve({path: '/project', query: {id: valarr[0]}})
          window.open(routerData.href, '_blank')
        })
      charts.setOption(this.option)
    },
    handleChangelable2(val) {
      let tbdataval = this.chartsData2
      var titleArray = []
      var dataArray = []
      for (var i = 0; i < this.topamVal; i++) {
        let project_id = tbdataval[i].project_id
        let head = tbdataval[i].head
        let institution = tbdataval[i].institution_english.substring(0, 20)+'...'
        let disestr = tbdataval[i].diseases
        let diseaval = ''
        disestr.length >20 ? diseaval = disestr.substring(0, 20)+'...' : diseaval = disestr
        let tissuesstr = tbdataval[i].tissues
        let tissuesval = ''
        tissuesstr.length >20 ? tissuesval = tissuesstr.substring(0, 20)+'...' : tissuesval = tissuesstr
        let addstr = ''
        // let species = tbdataval[i].species
        let speciesstr = tbdataval[i].species
        let speciesval = ''
        speciesstr.length >30 ? speciesval = speciesstr.substring(0, 30)+'...' : speciesval = speciesstr
        let species = speciesval
        let cellstr = tbdataval[i].cell
        let cellval = ''
        cellstr.length >10 ? cellval = cellstr.substring(0, 10)+'...' : cellval = cellstr
        let titlearr = project_id+'\n'+head+'\n'+institution+'\n'+species
        let addarr = '\n'
        if(diseaval != '') {
          addarr = addarr + diseaval
        }
        if(tissuesval != '' && diseaval != '') {
          addarr = addarr + '/'+tissuesval
        } else if(tissuesval != '' && diseaval == '') {
          addarr = addarr + tissuesval
        }
        if(tissuesval != '' && diseaval != '' && cellval != '') {
          addarr = addarr + '/' + cellval
        } else if(tissuesval != '' && diseaval == '' && cellval != '') {
          addarr = addarr + '/' + cellval
        } else if(tissuesval == '' && diseaval == '' && cellval != '') {
          addarr = addarr + cellval
        }
        titleArray.push(titlearr+addarr)
        dataArray.push(tbdataval[i].download_amount)
      }
      this.option2.xAxis.data = titleArray
      this.option2.series[0].data = dataArray
      this.option2.series[0].label.show = val
      this.option2.title.subtext = 'GB'
      let charts = this.$echarts.init(document.getElementById('myCharts2'))
      const _this = this
        charts.on('click', 'xAxis.category', function (params) {
          var clikName = params.value;
          let valarr = clikName.split("\n"); // 使用回车分割字符串
          let routerData = _this.$router.resolve({path: '/project', query: {id: valarr[0]}})
          window.open(routerData.href, '_blank')
        })
      charts.setOption(this.option2)
    },
    handleProurl(param) {
      let routerData = this.$router.resolve({path: '/project', query: {id: param}})
      window.open(routerData.href, '_blank')
    },
    handleCharts() {
      this.ajax_data_list.order.item = 'download_cnt'
      this.ajax_data_list.page.pageLength = parseInt(this.topnumVal)
      getStatDownloadData(this.ajax_data_list).then(res => {
        // this.loading = false
        // this.sData = res.result
        // this.allNum = res.count
        // var newArray = [...this.sData].splice(0, 10);
        this.chartsData1 = res.result
        let tbdataval = this.chartsData1
        var titleArray = []
        var dataArray = []
        for (var i = 0; i < this.topnumVal; i++) {
          let project_id = tbdataval[i].project_id
          let head = tbdataval[i].head
          let institution = tbdataval[i].institution_english.substring(0, 20)+'...'
          let disestr = tbdataval[i].diseases
          let diseaval = ''
          disestr.length >20 ? diseaval = disestr.substring(0, 20)+'...' : diseaval = disestr
          let tissuesstr = tbdataval[i].tissues
          let tissuesval = ''
          tissuesstr.length >20 ? tissuesval = tissuesstr.substring(0, 20)+'...' : tissuesval = tissuesstr
          let addstr = ''
          // let species = tbdataval[i].species
          let speciesstr = tbdataval[i].species
          let speciesval = ''
          speciesstr.length >30 ? speciesval = speciesstr.substring(0, 30)+'...' : speciesval = speciesstr
          let species = speciesval
          let cellstr = tbdataval[i].cell
          let cellval = ''
          cellstr.length >10 ? cellval = cellstr.substring(0, 10)+'...' : cellval = cellstr
          let titlearr = project_id+'\n'+head+'\n'+institution+'\n'+species
          let addarr = '\n'
          if(diseaval != '') {
            addarr = addarr + diseaval
          }
          if(tissuesval != '' && diseaval != '') {
            addarr = addarr + '/'+tissuesval
          } else if(tissuesval != '' && diseaval == '') {
            addarr = addarr + tissuesval
          }
          if(tissuesval != '' && diseaval != '' && cellval != '') {
            addarr = addarr + '/' + cellval
          } else if(tissuesval != '' && diseaval == '' && cellval != '') {
            addarr = addarr + '/' + cellval
          } else if(tissuesval == '' && diseaval == '' && cellval != '') {
            addarr = addarr + cellval
          }
          titleArray.push(titlearr+addarr)
          dataArray.push(tbdataval[i].download_cnt)
        }
        this.option.xAxis.data = titleArray
        this.option.series[0].data = dataArray
        this.option.title.subtext = '次'
        let charts = this.$echarts.init(document.getElementById('myCharts'))
        const _this = this
        charts.on('click', 'xAxis.category', function (params) {
          var clikName = params.value;
          let valarr = clikName.split("\n"); // 使用回车分割字符串
          let routerData = _this.$router.resolve({path: '/project', query: {id: valarr[0]}})
          window.open(routerData.href, '_blank')
        })
        charts.setOption(this.option)
        // console.log(titleArray)
      })
    },
    handleCharts2() {
      this.ajax_data_list.order.item = 'download_amount'
      getStatDownloadData(this.ajax_data_list).then(res => {
        // this.loading = false
        // this.sData = res.result
        // this.allNum = res.count
        // var newArray = [...this.sData].splice(0, 10);
        // this.chartsData2 = res.result
        this.chartsData2 = res.result
        let tbdataval = this.chartsData2
        var titleArray = []
        var dataArray = []
        for (var i = 0; i < this.topamVal; i++) {
          let project_id = tbdataval[i].project_id
          let head = tbdataval[i].head
          let institution = tbdataval[i].institution_english.substring(0, 20)+'...'
          let disestr = tbdataval[i].diseases
          let diseaval = ''
          disestr.length >20 ? diseaval = disestr.substring(0, 20)+'...' : diseaval = disestr
          let tissuesstr = tbdataval[i].tissues
          let tissuesval = ''
          tissuesstr.length >20 ? tissuesval = tissuesstr.substring(0, 20)+'...' : tissuesval = tissuesstr
          let addstr = ''
          // let species = tbdataval[i].species
          let speciesstr = tbdataval[i].species
          let speciesval = ''
          speciesstr.length >30 ? speciesval = speciesstr.substring(0, 30)+'...' : speciesval = speciesstr
          let species = speciesval
          let cellstr = tbdataval[i].cell
          let cellval = ''
          cellstr.length >10 ? cellval = cellstr.substring(0, 10)+'...' : cellval = cellstr
          let titlearr = project_id+'\n'+head+'\n'+institution+'\n'+species
          let addarr = '\n'
          if(diseaval != '') {
            addarr = addarr + diseaval
          }
          if(tissuesval != '' && diseaval != '') {
            addarr = addarr + '/'+tissuesval
          } else if(tissuesval != '' && diseaval == '') {
            addarr = addarr + tissuesval
          }
          if(tissuesval != '' && diseaval != '' && cellval != '') {
            addarr = addarr + '/' + cellval
          } else if(tissuesval != '' && diseaval == '' && cellval != '') {
            addarr = addarr + '/' + cellval
          } else if(tissuesval == '' && diseaval == '' && cellval != '') {
            addarr = addarr + cellval
          }
          titleArray.push(titlearr+addarr)
          dataArray.push(tbdataval[i].download_amount)
        }
        this.option2.xAxis.data = titleArray
        this.option2.series[0].data = dataArray
        this.option2.title.subtext = 'GB'
        let charts = this.$echarts.init(document.getElementById('myCharts2'))
        const _this = this
        charts.on('click', 'xAxis.category', function (params) {
          var clikName = params.value;
          let valarr = clikName.split("\n"); // 使用回车分割字符串
          let routerData = _this.$router.resolve({path: '/project', query: {id: valarr[0]}})
          window.open(routerData.href, '_blank')
        })
        // charts.on('click', 'xAxis.category', function (params) {
        //   var clikName = params.value;
        //   console.log(clikName)
        //   // this.$router.push({path: '/project', query: {id: clikName}})
        //   // let routerData = this.$router.resolve({path: '/project', query: {id: clikName}})
        //   // window.open(routerData.href, '_blank')
        // })
        charts.setOption(this.option2)
        // console.log(titleArray)
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
